'use client';

import { c as _c } from "react/compiler-runtime";
import { Button, Drawer as DrawerSparky, Icon, Logo } from '@petsmart-ui/sparky';
import type { Entry } from 'contentful';
import { useState } from 'react';
import { useCategoryStack } from '../../hooks';
import { DrawerMenuItem } from '../HeaderDrawerItem';
import type { HeaderDrawerProps } from './types';
import './HeaderDrawer.scss';
export function HeaderDrawer(t0) {
  const $ = _c(22);
  const {
    mainMenu
  } = t0;
  const [isActive, setisActive] = useState(false);
  let t1;
  if ($[0] !== mainMenu) {
    t1 = mainMenu?.fields?.category ? mainMenu.fields.category as Entry[] : [];
    $[0] = mainMenu;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  const {
    handleBackClick,
    handleCategoryClick,
    categoryStack,
    currentCategories
  } = useCategoryStack(t1);
  const t2 = isActive ? "Close" : "Menu";
  const t3 = isActive ? "x" : "menu";
  let t4;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = () => {
      setisActive(true);
    };
    $[2] = t4;
  } else {
    t4 = $[2];
  }
  let t5;
  if ($[3] !== t2 || $[4] !== t3) {
    t5 = <Button data-testid="menu-button" className="sparky-c-header__menu-button" variant="bare" text={t2} iconPosition="before" iconName={t3} size="lg" hideText={true} onClick={t4} />;
    $[3] = t2;
    $[4] = t3;
    $[5] = t5;
  } else {
    t5 = $[5];
  }
  let t6;
  if ($[6] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = () => setisActive(false);
    $[6] = t6;
  } else {
    t6 = $[6];
  }
  let t7;
  if ($[7] !== categoryStack.length || $[8] !== currentCategories.displayText || $[9] !== handleBackClick) {
    t7 = <DrawerSparky.Header>{categoryStack.length > 1 ? <div className="header-drawer header-drawer--top"><button data-testid="back-button" onClick={handleBackClick} className="category__button--back category__button" type="button"><Icon size="lg" name="chevron-left" /><span>{currentCategories.displayText}</span></button></div> : <Logo />}</DrawerSparky.Header>;
    $[7] = categoryStack.length;
    $[8] = currentCategories.displayText;
    $[9] = handleBackClick;
    $[10] = t7;
  } else {
    t7 = $[10];
  }
  let t8;
  if ($[11] !== categoryStack || $[12] !== currentCategories.categories || $[13] !== handleCategoryClick) {
    t8 = currentCategories.categories && <DrawerSparky.Body className="drawer-body"><ul data-testid="drawer-body" className={`menu-category menu-category--lvl${categoryStack.length}`}>{currentCategories.categories.filter(_temp).map(category_0 => <DrawerMenuItem key={category_0.sysId} categoryStack={categoryStack} category={category_0} handleCategoryClick={handleCategoryClick} closeMenu={() => setisActive(false)} />)}</ul></DrawerSparky.Body>;
    $[11] = categoryStack;
    $[12] = currentCategories.categories;
    $[13] = handleCategoryClick;
    $[14] = t8;
  } else {
    t8 = $[14];
  }
  let t9;
  if ($[15] !== isActive || $[16] !== t7 || $[17] !== t8) {
    t9 = <DrawerSparky className="drawer" isActive={isActive} onClose={t6} data-testid="header-drawer">{t7}{t8}</DrawerSparky>;
    $[15] = isActive;
    $[16] = t7;
    $[17] = t8;
    $[18] = t9;
  } else {
    t9 = $[18];
  }
  let t10;
  if ($[19] !== t5 || $[20] !== t9) {
    t10 = <>{t5}{t9}</>;
    $[19] = t5;
    $[20] = t9;
    $[21] = t10;
  } else {
    t10 = $[21];
  }
  return t10;
}
function _temp(category, index, self) {
  return index === self.findIndex(c => c.sysId === category.sysId);
}